// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"f7cf8e34e8b17ac4d21d","303":"0d43835390315c230b18","495":"caf2370859e1bf612b2c"}[chunkId] + ".js";
};